export default __webpack_public_path__ + "static/media/total-citizens.e3fe0b51.svg";